/* Chi naviga con il Tab deve VEDERE quello che ha messo a fuoco.
 *
 * IL DIFETTO, MISURATO
 * Sulla scheda prodotto, da desktop: si mette a fuoco "Aggiungi al carrello"
 * e la pagina non si muove. window.scrollY resta 0, il pulsante resta a
 * y=1693 su una finestra alta 900. Cioe' il fuoco della tastiera e' su un
 * pulsante che non si vede. Chi naviga con la tastiera preme Invio al buio,
 * o piu' probabilmente si arrende.
 *
 * PERCHE' SUCCEDE
 * Lo smooth-scroll di assets/motion.js (desktop >= 1000px) mette tutta la
 * pagina dentro un <div class="scroll-wrap"> in position:fixed e la fa
 * scorrere con un transform. La rotella del mouse continua a funzionare --
 * la finestra scorre davvero e il transform la insegue -- ma il browser, per
 * portare un elemento a fuoco sotto gli occhi, cerca un antenato scorribile:
 * dentro un elemento fisso non ne trova nessuno, e sta fermo. Per lo stesso
 * motivo scrollIntoView() non fa niente su questa pagina.
 *
 * COSA FA QUESTO FILE
 * Quando il fuoco arriva su qualcosa che sta fuori dallo schermo, sposta la
 * finestra quel tanto che basta a farlo vedere. Solo per il fuoco DA
 * TASTIERA (:focus-visible): un clic col mouse non deve far saltare la
 * pagina sotto le dita di chi ha appena cliccato.
 *
 * LA MATEMATICA, E PERCHE' NON BASTA window.scrollY
 * Con lo smooth-scroll acceso il transform insegue la finestra con un
 * ritardo: nell'istante del fuoco, rect.top dice dove l'elemento si vede
 * ADESSO, mentre window.scrollY dice dove la finestra sta ANDANDO. Sommarli
 * porterebbe troppo in la'. motion.js pubblica la posizione vera del
 * transform in window.__perlaScrollY: si usa quella quando c'e', e si ricade
 * su window.scrollY quando lo smooth-scroll e' spento (telefono, schermo
 * stretto, o chi ha chiesto meno animazioni).
 */
(function () {
  'use strict';

  // quanto respiro lasciare sopra l'elemento messo a fuoco
  var MARGINE = 120;

  function offsetPagina() {
    // motion.js la aggiorna a ogni fotogramma; senza smooth-scroll non esiste
    return typeof window.__perlaScrollY === 'number' ? window.__perlaScrollY : window.scrollY;
  }

  function daTastiera(el) {
    // Il fuoco da mouse non deve muovere la pagina. :focus-visible e' la
    // regola del browser su cosa merita un anello di fuoco, ed e' la stessa
    // distinzione che serve qui. Se il browser non la conosce si preferisce
    // NON muovere niente: meglio non aiutare che far saltare la pagina.
    try { return el.matches(':focus-visible'); } catch (e) { return false; }
  }

  function fuoriDallaFinestra(r) {
    return r.top < 0 || r.bottom > window.innerHeight;
  }

  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!el || !el.getBoundingClientRect || el === document.body) return;
    if (!daTastiera(el)) return;

    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return;   // elemento nascosto
    if (!fuoriDallaFinestra(r)) return;            // si vede gia': non si tocca

    // dove sta l'elemento nella pagina intera, non nella finestra
    var assoluta = r.top + offsetPagina();
    var meta = Math.max(0, assoluta - MARGINE);

    var pianoPiano = !window.matchMedia
      || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: meta, behavior: pianoPiano ? 'smooth' : 'auto' });
    } catch (err) {
      window.scrollTo(0, meta);   // browser vecchi: senza opzioni
    }
  }, true);
})();

/* E un link con l'ancora deve arrivare all'ancora.
 *
 * ROUND 71. Il pulsante "Fai il quiz" della pagina chi-siamo aveva il link
 * VUOTO e apriva il catalogo intero; il quiz sta in home, e il posto giusto
 * era /#quiz. Ma con lo smooth-scroll di motion.js (desktop >= 1000px) la
 * pagina vive dentro un contenitore position:fixed, e per la stessa ragione
 * scritta in testa a questo file il browser, arrivando su /#quiz, non trova
 * niente da scorrere e resta in cima. Quindi al caricamento, se l'indirizzo ha
 * un'ancora che esiste, si porta la finestra li' con la stessa matematica di
 * sopra. Senza smooth-scroll (telefono, meno animazioni) il browser lo fa gia'
 * da solo, e questa funzione non trova niente da correggere.
 */
(function () {
  'use strict';

  function vaiAllAncora() {
    var h = window.location.hash;
    if (!h || h.length < 2) return;
    var el;
    try { el = document.getElementById(decodeURIComponent(h.slice(1))); } catch (e) { return; }
    if (!el) return;
    var r = el.getBoundingClientRect();
    var sopra = typeof window.__perlaScrollY === 'number' ? window.__perlaScrollY : window.scrollY;
    var meta = Math.max(0, r.top + sopra - 90);   // 90: l'altezza della testata
    if (Math.abs((window.scrollY || 0) - meta) < 4) return;
    window.scrollTo(0, meta);
  }

  // dopo il load: motion.js misura l'altezza della pagina solo allora
  if (document.readyState === 'complete') setTimeout(vaiAllAncora, 60);
  else window.addEventListener('load', function () { setTimeout(vaiAllAncora, 60); });
})();

/* E il fuoco non deve USCIRE da una sovrapposizione che si dichiara modale.
 *
 * IL DIFETTO, LETTO NEL MARKUP E NEL BUNDLE
 * theme.liquid:428 e :443 rendono le due sovrapposizioni a schermo pieno --
 * la ricerca e il menu -- e tutt'e due dichiarano
 *
 *     role="dialog" aria-modal="true"
 *
 * aria-modal="true" e' una PROMESSA fatta alle tecnologie assistive: dice
 * "il resto della pagina non conta, mentre sono aperta". Nessuno la mantiene.
 * In assets/motion.js l'apertura fa esattamente tre cose -- aggiunge
 * is-open, scrive aria-hidden="false", mette una classe sul body -- e la
 * chiusura le disfa. Non c'e' nessuna trappola del Tab, e il menu non sposta
 * il fuoco nemmeno all'apertura (la ricerca almeno mette a fuoco il suo
 * campo dopo 260 ms).
 *
 * Quindi, da tastiera: si apre il menu e il fuoco resta DIETRO, sulla pagina
 * coperta. Si tabula dentro link che non si vedono, sotto un pannello opaco,
 * senza capire dove si e'. E alla chiusura il fuoco non torna al pulsante che
 * l'aveva aperta: riparte da capo.
 *
 * PERCHE' QUI E NON IN motion.js
 * Stessa ragione del resto del file e di perla-tendine.js: motion.js e' una
 * riga sola da 25.315 byte, minificata, e il sorgente leggibile non esiste.
 * Qui si aggiunge; la' si romperebbe.
 *
 * COME RICONOSCE L'APERTURA
 * Non ci si aggancia ai gestori di motion.js, che non sono raggiungibili: si
 * guarda il DOM. Un MutationObserver su class e aria-hidden di ogni
 * [role=dialog][aria-modal=true] dice quando si apre e quando si chiude, e
 * la condizione e' quella che motion.js scrive davvero. Se domani cambiasse
 * il modo di aprire, questo codice segue invece di contraddire -- e se
 * sparisse, le sovrapposizioni tornerebbero come sono oggi.
 */
(function () {
  'use strict';

  var ATTIVABILI = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled])',
    'select:not([disabled])', 'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var chiAperto = null;     // la sovrapposizione aperta adesso
  var chiHaAperto = null;   // l'elemento a cui restituire il fuoco

  function aperta(el) {
    if (el.getAttribute('aria-hidden') === 'false') return true;
    return /(^|\s)is-open(\s|$)/.test(el.className || '');
  }

  function attivabiliDentro(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll(ATTIVABILI),
      function (n) {
        // niente di alto zero: i pannelli chiusi e gli elementi nascosti non
        // sono tappe del Tab (e' lo stesso criterio di perla-tendine.js)
        var r = n.getBoundingClientRect();
        return (r.width > 0 || r.height > 0) && !n.hasAttribute('hidden');
      });
  }

  function siApre(el) {
    chiAperto = el;
    // chi l'ha aperta: si ricorda PRIMA di spostare il fuoco
    var precedente = document.activeElement;
    chiHaAperto = (precedente && precedente !== document.body) ? precedente : null;

    var dentro = attivabiliDentro(el);
    if (dentro.length) {
      dentro[0].focus();
    } else {
      // una sovrapposizione senza niente da mettere a fuoco: almeno il fuoco
      // entra, invece di restare sulla pagina dietro
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      el.focus();
    }
  }

  function siChiude(el) {
    if (chiAperto !== el) return;
    chiAperto = null;
    if (chiHaAperto && document.contains(chiHaAperto)) {
      try { chiHaAperto.focus(); } catch (e) { /* elemento andato: pazienza */ }
    }
    chiHaAperto = null;
  }

  // La trappola. In cattura, perche' deve decidere prima di chiunque altro.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !chiAperto || !aperta(chiAperto)) return;
    var dentro = attivabiliDentro(chiAperto);
    if (!dentro.length) { e.preventDefault(); return; }
    var primo = dentro[0];
    var ultimo = dentro[dentro.length - 1];
    var corrente = document.activeElement;

    if (!chiAperto.contains(corrente)) {
      // il fuoco e' scappato fuori (o non e' mai entrato): lo si riporta
      e.preventDefault();
      (e.shiftKey ? ultimo : primo).focus();
      return;
    }
    if (e.shiftKey && corrente === primo) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && corrente === ultimo) {
      e.preventDefault();
      primo.focus();
    }
  }, true);

  function sorveglia() {
    var modali = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    Array.prototype.forEach.call(modali, function (el) {
      if (el.__fuocoLegato || typeof window.MutationObserver !== 'function') return;
      el.__fuocoLegato = true;
      var eraAperta = aperta(el);
      new window.MutationObserver(function () {
        var ora = aperta(el);
        if (ora === eraAperta) return;
        eraAperta = ora;
        if (ora) siApre(el); else siChiude(el);
      }).observe(el, {
        attributes: true, attributeFilter: ['class', 'aria-hidden']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sorveglia);
  } else {
    sorveglia();
  }
  document.addEventListener('shopify:section:load', sorveglia);
})();

/* ROUND 74 -- IL POPUP DELLO SCONTO SI APRIVA MUTO.
 *
 * snippets/newsletter-popup.liquid: il guscio .popup-overlay nasce con
 * aria-hidden="true", e dentro c'e' il vero role="dialog" aria-modal="true".
 * global.js lo apre mettendo is-open sul GUSCIO e bloccando lo scorrimento,
 * ma aria-hidden non lo tocca mai. Visto dal vivo il 25 settembre 2026 in
 * Chromium: popup aperto, aria-hidden="true", fuoco rimasto sulla pagina
 * dietro. Per un lettore di schermo il popup non esiste mentre copre tutto e
 * blocca la pagina; e la trappola qui sopra non scattava, perche' guarda
 * class e aria-hidden del dialogo, non del guscio.
 *
 * Qui si tiene aria-hidden allineato a is-open, sul guscio e sul dialogo. Il
 * secondo cambio e' quello che la trappola sopra osserva: cosi' il fuoco
 * entra all'apertura, resta dentro col Tab e torna indietro alla chiusura,
 * senza una seconda trappola.
 */
(function () {
  'use strict';

  function lega() {
    var guscio = document.querySelector('.popup-overlay');
    if (!guscio || guscio.__ariaLegato || typeof window.MutationObserver !== 'function') return;
    guscio.__ariaLegato = true;
    var dialogo = guscio.querySelector('[role="dialog"]');
    function allinea() {
      var aperto = guscio.classList.contains('is-open') ? 'false' : 'true';
      if (guscio.getAttribute('aria-hidden') !== aperto) guscio.setAttribute('aria-hidden', aperto);
      if (dialogo && dialogo.getAttribute('aria-hidden') !== aperto) dialogo.setAttribute('aria-hidden', aperto);
    }
    // solo 'class': aria-hidden lo scrive allinea() stessa, e osservarlo
    // la farebbe richiamare da sola
    new window.MutationObserver(allinea).observe(guscio, { attributes: true, attributeFilter: ['class'] });
    allinea();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lega);
  } else {
    lega();
  }
})();
